import { Star, Quote } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { useLang, IMG, REVIEW_URL } from "../lib/i18n";

export const Reviews = () => {
  const { t } = useLang();
  const r = t.reviews;
  return (
    <section id="reviews" data-testid="reviews-section" className="bg-[#F6F2EC] py-24 sm:py-36">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10">
        <Reveal><p className="overline text-[#8A6A3A] mb-6">{r.over}</p></Reveal>
        <Reveal delay={0.05}><h2 className="font-serif-d font-light text-[2.6rem] sm:text-6xl leading-[1] text-[#14110F] max-w-3xl">{r.title}</h2></Reveal>
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-4">
          <Reveal className="lg:col-span-4">
            <div data-testid="reviews-score-card" className="relative overflow-hidden h-full bg-[#14110F] text-[#F6F2EC] p-8 sm:p-10 flex flex-col justify-between min-h-[420px]">
              <img src={IMG.realDark} alt="Gioia Anfosso al lavoro" className="absolute inset-0 w-full h-full object-cover object-[60%_20%] opacity-55" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#14110F] via-[#14110F]/50 to-transparent" />
              <span className="relative overline text-[#C9A66B]">Google</span>
              <div className="relative">
                <div className="font-serif-d font-light text-[7rem] sm:text-[9rem] leading-[0.85]">4,8</div>
                <div className="flex gap-1 mt-4">{[0, 1, 2, 3, 4].map((i) => <Star key={i} className={`w-5 h-5 ${i < 4 ? "fill-[#C9A66B]" : "fill-[#C9A66B]/60"} text-[#C9A66B]`} />)}</div>
                <p className="mt-4 text-sm text-[#b8ad9f]">{r.based}</p>
                <a href={REVIEW_URL} target="_blank" rel="noreferrer" data-testid="reviews-leave-link" className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#C9A66B] px-6 py-3 text-[0.7rem] tracking-[0.2em] uppercase text-[#C9A66B] transition-colors duration-500 hover:bg-[#C9A66B] hover:text-[#14110F]">
                  <Star className="w-3.5 h-3.5" /> {r.leave}
                </a>
              </div>
            </div>
          </Reveal>
          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
            {r.quotes.map((q, i) => (
              <motion.figure
                key={q}
                data-testid={`review-card-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                whileHover={{ y: -6 }}
                transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className={`bg-[#ECE5DA] p-8 sm:p-10 flex flex-col justify-between gap-10 ${i === 0 ? "sm:col-span-2" : ""}`}
              >
                <Quote className="w-7 h-7 text-[#8A6A3A]" strokeWidth={1} />
                <blockquote className={`font-serif-d font-light text-[#14110F] leading-[1.15] ${i === 0 ? "text-3xl sm:text-5xl" : "text-2xl sm:text-3xl"}`}>“{q}”</blockquote>
                <figcaption className="flex items-center gap-1">{[0, 1, 2, 3, 4].map((k) => <Star key={k} className="w-3.5 h-3.5 fill-[#8A6A3A] text-[#8A6A3A]" />)}<span className="ml-3 text-xs tracking-[0.2em] uppercase text-[#5a534c]">Google</span></figcaption>
              </motion.figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
